/**
 * Shared helpers for the Documents Vault UI.
 * Keeps category labels + icon hints in one place so the upload modal,
 * the global vault, and the tenant-profile tab all stay in sync.
 */

export const CATEGORY_LABELS = {
  // Property
  lease_deed:        'Lease Deed',
  fssai:             'FSSAI Certificate',
  fire_noc:          'Fire NOC',
  gst_cert:          'GST Certificate',
  property_tax:      'Property Tax',
  electricity_bill:  'Electricity Bill',
  insurance:         'Insurance',
  // Tenant
  aadhaar_front:     'Aadhaar (Front)',
  aadhaar_back:      'Aadhaar (Back)',
  pan:               'PAN Card',
  police_verification: 'Police Verification',
  rent_agreement:    'Rent Agreement',
  photo:             'Photo',
  employer_letter:   'Employer Letter',
  // Both
  other:             'Other',
};

export const PROPERTY_CATEGORIES = [
  'lease_deed', 'fssai', 'fire_noc', 'gst_cert',
  'property_tax', 'electricity_bill', 'insurance', 'other',
];

export const TENANT_CATEGORIES = [
  'aadhaar_front', 'aadhaar_back', 'pan', 'police_verification',
  'rent_agreement', 'photo', 'employer_letter', 'other',
];

export const SENSITIVE_CATEGORIES = new Set([
  'aadhaar_front', 'aadhaar_back', 'pan', 'police_verification', 'employer_letter',
]);

export const MAX_FILE_SIZE = 5 * 1024 * 1024;  // 5 MB

export const ALLOWED_MIME = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/webp',
];

export const formatBytes = (b) => {
  if (!b) return '0 B';
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
  return `${(b / 1024 / 1024).toFixed(2)} MB`;
};

/** File → base64 (strips the `data:...;base64,` prefix). */
export const fileToBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => {
    const result = reader.result || '';
    const comma = String(result).indexOf(',');
    resolve(comma >= 0 ? String(result).slice(comma + 1) : String(result));
  };
  reader.onerror = reject;
  reader.readAsDataURL(file);
});

/** Mime → small descriptive icon emoji. Used inside coloured chips. */
export const mimeIcon = (mime) => {
  if (mime === 'application/pdf') return 'PDF';
  if ((mime || '').startsWith('image/')) return 'IMG';
  return 'FILE';
};
